<template>
  <div class="roleSet">
    <div v-if="$route.path === '/basicdata/rolesetting'" class="right">
      <div class="operation">
        <div class="operationBtn">
          <el-button @click="delRolesData" :disabled="delDisabled">{{$t('LanguageLib.DELETE')}}</el-button>
          <el-button type="primary" @click="addOrg">{{$t('LanguageLib.ADD_TO')}}</el-button>
          <el-dropdown trigger="click">
            <el-button type="primary">{{$t('LanguageLib.ImportOrExport')}}</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :title="$t('LanguageLib.DOWNLOAD_TEMPLATE')" @click.native.prevent="downExcal">{{$t('LanguageLib.DOWNLOAD_TEMPLATE')}}</el-dropdown-item>
              <el-dropdown-item :title="$t('LanguageLib.IMPORT_ROLES')">
                <el-upload
                  class="upload"
                  name="files"
                  :data="formData"
                  :action="uploadApi"
                  :headers="headers()"
                  :on-preview="handlePreview"
                  :before-upload="beforeUpload"
                  :on-error="onError"
                  :on-success="onSuccess"
                  :show-file-list="false"
                  accept=".xlsx, .xls">
                  <el-button :plain="true" style="padding: 0px;border: none;color: #666;">{{$t('LanguageLib.IMPORT_ROLES')}}</el-button>
                </el-upload>
              </el-dropdown-item>
              <el-dropdown-item :title="$t('LanguageLib.EXPORT_EXCEL')" @click.native.prevent="exportExcal">{{$t('LanguageLib.EXPORT_EXCEL')}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="operationSearch">
          <el-input
            placeholder=""
            prefix-icon="el-icon-search"
            v-model="searchText"
            @keyup.enter.native="searchDomainList"
          >
          </el-input>
        </div>
      </div>
      <div class="tableParent">
        <el-table
          empty-text=" "
          class="table-fixed"
          :data="tableData"
          stripe
          @selection-change="selectionChange"
          @sort-change='sortChange'
          :default-sort="defaultSort"
          ref="table"
          style="width: auto;"
          v-loading="loading"
          height="100%">
          <el-table-column
            type="selection"
            :disabled="true"
            width="45">
          </el-table-column>
          <el-table-column
            prop="sortNo"
            :label="$t('LanguageLib.SERIAL_NUMBER')"
            sortable="custom"
            min-width="150">
            <template slot-scope="scope" class="code">
              <el-tooltip class="code" effect="light" placement="top-start" >
                <span slot="content" type="sortNo">{{scope.row.sortNo}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="sortNo">{{scope.row.sortNo}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="roleName"
            :label="$t('LanguageLib.ROLE_NAME')"
            sortable="custom"
            min-width="120">
            <template slot-scope="scope" class="code">
              <el-tooltip effect="light" placement="top-start" class="code">
                <span slot="content" type="roleName">{{scope.row.roleName}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="roleName">{{scope.row.roleName}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="domainTypeName"
            :label="$t('LanguageLib.ORGANIZATION_TYPE')"
            sortable="custom"
            min-width="175">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="domainTypeName">{{scope.row.domainTypeName}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="domainTypeName">{{scope.row.domainTypeName}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="rank"
            :label="$t('LanguageLib.USER_TYPE')"
            sortable="custom"
            min-width="120">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="rank">{{$commonfun.getUserTypeName(scope.row.rank)}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="rank">{{$commonfun.getUserTypeName(scope.row.rank)}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="allowedMultiUser"
            :label="$t('LanguageLib.WHETHER_ALLOW_MULTIPLE_PEOPLE')"
            sortable="custom"
            min-width="150">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="allowedMultiUser">{{$commonfun.showAllowStr(scope.row.allowedMultiUser)}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="allowedMultiUser">{{$commonfun.showAllowStr(scope.row.allowedMultiUser)}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="hasUsing"
            :label="$t('LanguageLib.HAVE_A_JOB')"
            min-width="80">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="hasUsing">{{$commonfun.showHaveStr(scope.row.hasUsing)}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="hasUsing">{{$commonfun.showHaveStr(scope.row.hasUsing)}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="updateDate"
            :label="$t('LanguageLib.LAST_UPDATED')"
            sortable="custom"
            min-width="180">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start">
                <span slot="content" type="updateDate">{{$commonfun.formatDate(scope.row.updateDate,'1')}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: middle;" type="updateDate">{{$commonfun.formatDate(scope.row.updateDate,'1')}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            :label="$t('LanguageLib.Operation')"
            min-width="100">
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="editRole(scope.row, scope.$index, tableData)"
                v-if="scope.row.isAllowOperation"
                :title="$t('LanguageLib.Edit')"
                type="text"
                style="color:#fff;width:30px;height:30px;background-color:#3bc6b9;border-radius:50%;line-height:30px;padding:0;">
                <i class="iconfont">&#xe60c;</i>
              </el-button>
              <el-button
                @click.native.prevent="editRole(scope.row, scope.$index, tableData)"
                v-if="!scope.row.isAllowOperation"
                :title="$t('LanguageLib.Edit')"
                type="text"
                style="color:#fff;width:30px;height:30px;background-color:#ccc;border-radius:50%;line-height:30px;padding:0;">
                <i class="iconfont">&#xe60c;</i>
              </el-button>
              <el-button
                @click.native.prevent="editRoleJurisdiction(scope.row, scope.$index, tableData)"
                :title="$t('LanguageLib.MODIFY_ROLE_PERMISSIONS')"
                type="text"
                style="color:#fff;width:30px;height:30px;background-color:#3bc6b9;border-radius:50%;line-height:30px;padding:0;">
                <i class="iconfont">&#xe60e;</i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>
    <!--导出excal-->
    <el-dialog :title="$t('LanguageLib.SELECT_EXPORT_FIELD')" :visible.sync="dialogExcal" class="ExcalDialog dialogList" :before-close="closeDialog" :close-on-click-modal="false">
      <div class="checkFiled">
        <el-form>
          <div class="contentTop">
              <el-radio v-model="allField" :label="item.label" v-for="item in FieldData" :key="item.label" @change="handleCheckAllChange">{{item.name}}</el-radio >
          </div>
          <div class="basicsField">
            <h4>{{$t('LanguageLib.BASE_FIELD')}}</h4>
            <div class="basicsFieldChild">
              <el-checkbox-group v-model="checkedFields">
                <el-checkbox v-for="item in Fields" :label="item" :key="item" :disabled="allField == '2'">{{item}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div class="customField">
            <h4>{{$t('LanguageLib.CUSTOM_FIELD')}}</h4>
          </div>
        </el-form>
      </div>
      <div class="showFiled">
        <p style="color: #999999;">{{$t('LanguageLib.CURRENT_SELECT_FIELD')}}</p>
        <ul>
          <li v-for="item in checkedFields" :key="item"><span>{{item}}</span><i class="el-icon-close" @click="delField(item)" v-if="allField == '1'"></i></li>
        </ul>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit()" :loading="loadingSave">{{$t('LanguageLib.DETERMINE')}}</el-button>
      </div>
    </el-dialog>
    <router-view v-if="$route.path !== '/basicdata/rolesetting'"></router-view>
  </div>
</template>

<script>
import basicdataApi from '../../api/basicdata'
import baseUrl from '@/utils/base'
export default {
  props: {
    msg: String
  },
  data () {
    return {
      uploadApi: baseUrl.uploadApi, // 上传地址
      formData: { path: 'images' },
      FileData: {
        FileName: '', // 文件名称
        FilePath: '', // 文件地址
        EnumImportType: 11000 // 导入类型 11000为角色导入
      }, // 人员文件导入参数
      dialogExcal: false, // 是否显示导出excal弹框
      loading: true, // loading状态
      tableData: [], // 列表数据
      pageTotal: 0, // 数据总数
      delDisabled: true, // 删除按钮默认禁用
      selectDomainData: [], // 选中的组织数据
      // 请求数据列表的函数
      getRoleList: (pageIndex, pageSize, sort, IsAsc, AllowedMultiUser, DomainTypeIds, Ranks, searchVal) => {
        this.loading = true
        basicdataApi.GetRoleList('post', '/role/page', { pageIndex: pageIndex, pageSize: pageSize, sort: sort, IsAsc: IsAsc, AllowedMultiUser: AllowedMultiUser, DomainTypeIds: DomainTypeIds, Ranks: Ranks, searchVal: searchVal })
          .then(res => {
            this.$commonfun.console.log(res)
            this.tableData = res.data.data
            this.pageTotal = res.data.total
            this.loading = false
          })
          .catch(err => {
            this.$commonfun.console.log(err)
          })
      }, // 请求数据列表的函数
      searchText: '', // 列表搜索关键词
      currentPage: 1, // 默认显示第1页数据
      pageSize: 20, // 默认每页显示20条数据
      sort: 5, // 排序字段 0：序号 1：角色名称 2：组织类型名称 3：用户类型 4：是否允许多人任职 5：更新时间
      IsAsc: false, // 是否顺序
      AllowedMultiUser: -1, // 是否允许多人任职 -1:ALL 0：否 1:是
      domainTypeIds: [], // 组织类型Id列表
      ranks: [], // 用户类型Id列表
      defaultSort: { prop: 'updateDate', order: 'descending' }, // 默认显示排序
      prevSort: 'descending', // 记录前一次的排序状态（elementUI默认有三种，即descending，ascending和null）
      prevProp: 'updateDate', // 记录前一次的prop值
      updataRouteQuery: () => {
        const query = this.$router.history.current.query
        const path = this.$router.history.current.path
        const newQuery = JSON.parse(JSON.stringify(query))
        newQuery.currentPage = this.currentPage
        newQuery.pageSize = this.pageSize
        newQuery.searchText = this.$commonfun.encodeUrl(this.searchText)
        newQuery.sort = this.sort
        newQuery.IsAsc = this.IsAsc
        newQuery.NoRefresh = true
        this.$router.push({ path, query: newQuery })
      },
      loadingSave: false, // 保存按钮加loding
      allField: '2', // 导出excal-所有字段
      isIndeterminate: false, // 导出excal-所有字段勾选框状态
      FieldData: [
        // {
        //   name: this.$t('LanguageLib.SELECT_VIEW'),
        //   label: '1'
        // },
        {
          name: this.$t('LanguageLib.EXPORT_FOLLOW_UP'),
          label: '2'
        }
      ], // 导出查看/导出跟进
      checkedFields: [this.$t('LanguageLib.ROLE_NAME'), this.$t('LanguageLib.ORGANIZATION_TYPE'), this.$t('LanguageLib.USER_TYPE'), this.$t('LanguageLib.WHETHER_ALLOW_MULTIPLE_PEOPLE'), this.$t('LanguageLib.REMARK2')], // 已选中的字段
      Fields: [this.$t('LanguageLib.ROLE_NAME'), this.$t('LanguageLib.ORGANIZATION_TYPE'), this.$t('LanguageLib.USER_TYPE'), this.$t('LanguageLib.WHETHER_ALLOW_MULTIPLE_PEOPLE'), this.$t('LanguageLib.REMARK2')]
    }
  },
  created () {
    if (this.$route.query.currentPage) {
      this.currentPage = this.$route.query.currentPage * 1
      this.pageSize = this.$route.query.pageSize * 1
      this.searchText = this.$commonfun.decodeUrl(this.$route.query.searchText)
      this.sort = this.$route.query.sort * 1
      this.IsAsc = this.$route.query.IsAsc ? JSON.parse(this.$route.query.IsAsc) : false
      this.AllowedMultiUser = this.$route.query.AllowedMultiUser ? JSON.parse(this.$route.query.AllowedMultiUser) : -1
      this.domainTypeIds = this.$route.query.domainTypeIds ? JSON.parse(this.$route.query.domainTypeIds) : []
      this.ranks = this.$route.query.ranks ? JSON.parse(this.$route.query.ranks) : []
      switch (this.sort) {
        case 0:
          if (this.IsAsc) {
            this.defaultSort = { prop: 'sortNo', order: 'ascending' }
            this.prevSort = 'ascending'
          } else {
            this.defaultSort = { prop: 'sortNo', order: 'descending' }
            this.prevSort = 'descending'
          }
          this.prevProp = 'sortNo'
          break
        case 1:
          if (this.IsAsc) {
            this.defaultSort = { prop: 'roleName', order: 'ascending' }
            this.prevSort = 'ascending'
          } else {
            this.defaultSort = { prop: 'roleName', order: 'descending' }
            this.prevSort = 'descending'
          }
          this.prevProp = 'roleName'
          break
        case 2:
          if (this.IsAsc) {
            this.defaultSort = { prop: 'domainTypeName', order: 'ascending' }
            this.prevSort = 'ascending'
          } else {
            this.defaultSort = { prop: 'domainTypeName', order: 'descending' }
            this.prevSort = 'descending'
          }
          this.prevProp = 'domainTypeName'
          break
        case 3:
          if (this.IsAsc) {
            this.defaultSort = { prop: 'rank', order: 'ascending' }
            this.prevSort = 'ascending'
          } else {
            this.defaultSort = { prop: 'rank', order: 'descending' }
            this.prevSort = 'descending'
          }
          this.prevProp = 'rank'
          break
        case 4:
          if (this.IsAsc) {
            this.defaultSort = { prop: 'allowedMultiUser', order: 'ascending' }
            this.prevSort = 'ascending'
          } else {
            this.defaultSort = { prop: 'allowedMultiUser', order: 'descending' }
            this.prevSort = 'descending'
          }
          this.prevProp = 'allowedMultiUser'
          break
        case 5:
          if (this.IsAsc) {
            this.defaultSort = { prop: 'updateDate', order: 'ascending' }
            this.prevSort = 'ascending'
          } else {
            this.defaultSort = { prop: 'updateDate', order: 'descending' }
            this.prevSort = 'descending'
          }
          this.prevProp = 'updateDate'
          break
      }
    }
    this.getRoleList(this.currentPage, this.pageSize, this.sort, this.IsAsc, this.AllowedMultiUser, this.domainTypeIds, this.ranks, this.searchText)
  },
  methods: {
    // 列表排序
    sortChange (column) {
      if (column.order !== null) {
        this.prevSort = column.order
        if (column.order === 'ascending') {
          this.IsAsc = true
          this.prevSort = 'ascending'
        } else if (column.order === 'descending') {
          this.prevSort = 'descending'
          this.IsAsc = false
        }
        if (this.prevProp !== column.prop) {
          var columns = this.$refs.table.columns.find(item => item.property === this.prevProp)
          columns.order = ''
        }
      }
      if (column.order === null) {
        column.column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        this.prevProp = column.prop
        this.prevSort = column.column.order
        this.IsAsc = column.column.order !== 'descending'
      }
      switch (column.prop) {
        case 'sortNo':
          this.sort = 0
          break
        case 'roleName':
          this.sort = 1
          break
        case 'domainTypeName':
          this.sort = 2
          break
        case 'rank':
          this.sort = 3
          break
        case 'allowedMultiUser':
          this.sort = 4
          break
        case 'updateDate':
          this.sort = 5
          break
      }
      this.updataRouteQuery()
      // 请求列表接口数据
      this.getRoleList(this.currentPage, this.pageSize, this.sort, this.IsAsc, this.AllowedMultiUser, this.domainTypeIds, this.ranks, this.searchText)
    },
    // 页数改变
    handleSizeChange (val) {
      this.pageSize = val
      this.updataRouteQuery()
      // 请求列表接口数据
      this.getRoleList(this.currentPage, this.pageSize, this.sort, this.IsAsc, this.AllowedMultiUser, this.domainTypeIds, this.ranks, this.searchText)
    },
    // 每页条数改变
    handleCurrentChange (val) {
      this.currentPage = val
      this.updataRouteQuery()
      // 请求列表接口数据
      this.getRoleList(this.currentPage, this.pageSize, this.sort, this.IsAsc, this.AllowedMultiUser, this.domainTypeIds, this.ranks, this.searchText)
    },
    // 列表模糊搜索
    searchDomainList () {
      this.updataRouteQuery()
      this.currentPage = 1
      this.getRoleList(this.currentPage, this.pageSize, this.sort, this.IsAsc, this.AllowedMultiUser, this.domainTypeIds, this.ranks, this.searchText)
    },
    // 删除角色数据
    delRolesData () {
      this.$commonfun.confirm(this.$t('LanguageLib.ARE_YOU_SURE_YOU_WANT_TO_DELETE_IT1'), this.$t('LanguageLib.DELETE'), this.$t('LanguageLib.DETERMINE'), this.$t('LanguageLib.CANCEL'), false, 'warning', this)
        .then(() => {
          console.log(this.selectRoleData)
          basicdataApi.DelRolesData('post', '/role/delete', this.selectRoleData)
            .then(res => {
              this.currentPage = 1
              this.getRoleList(this.currentPage, this.pageSize, this.sort, this.IsAsc, this.AllowedMultiUser, this.domainTypeIds, this.ranks, this.searchText)
              this.$message({
                type: 'success',
                message: this.$t('LanguageLib.SUCCESSFULLY_DELETED')
              })
            })
            .catch(err => {
              this.$commonfun.console.log(err)
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('LanguageLib.DeletionCancelled')
          })
        })
    },
    // 角色批量选择
    selectionChange (selection) {
      this.selectRoleData = []
      for (let i = 0; i < selection.length; i++) {
        this.selectRoleData.push(selection[i].id)
      }
      if (this.selectRoleData.length === 0) {
        this.delDisabled = true
      } else {
        this.delDisabled = false
      }
    },
    // 导入模板
    headers () {
      return { token: this.$commonfun.localStorage.getitem('token'), lang: this.$commonfun.localStorage.getitem('lang') }
    },
    handlePreview (file) {
    },
    beforeUpload (file) {
      const type = file.name.slice(file.name.lastIndexOf('.'), file.name.length)
      if (type !== '.xlsx' && type !== '.xls' && type !== '.XLSX' && type !== '.XLS') {
        this.$message.success(this.$t('LanguageLib.FILE_FORMAT_ERROR_PLEASE_UPLOAD_EXCAL'))
        return false
      }
    },
    // 上传失败
    onError (file) {
      this.$message.success(this.$t('LanguageLib.UPLOAD_FAILED'))
    },
    // 上传成功-导入角色
    onSuccess (file, response) {
      this.FileData.FilePath = file[0]
      this.FileData.FileName = response.name
      basicdataApi.importinfoImportUser('post', '/importinfo/create', this.FileData)
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('LanguageLib.FILE_ALREADY_UPLOAD_YOU_CAN_VIEW_IMPORT_ASSISTANT')
          })
          this.getRoleList(this.currentPage, this.pageSize, this.sort, this.IsAsc, this.AllowedMultiUser, this.domainTypeIds, this.ranks, this.searchText)
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    },
    // 下载导入模板
    downExcal () {
      basicdataApi.UserDownExcal('get', '/basicdata/exceltemplate?template=10')
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('LanguageLib.DOWNLOAD_SUCCESSFUL')
          })
          this.dialogExcal = false
          var currentDay = this.$commonfun.formatDate(new Date().toISOString(), '4')
          var filename = this.$t('LanguageLib.ROLE_DATA_TEMPLATE') + '_' + currentDay + '.xlsx'
          var a = document.createElement('a')
          var url = window.URL.createObjectURL(new Blob([res.data]))
          a.href = url
          a.download = filename
          a.click()
          window.URL.revokeObjectURL(url)
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    },
    // 导出excal
    exportExcal () {
      this.dialogExcal = true
    },
    // 导出跟进字段全部选中
    handleCheckAllChange () {
      this.checkedFields = JSON.parse(JSON.stringify(this.Fields))
    },
    // 取消选中字段
    delField (type) {
      for (let i = 0; i < this.checkedFields.length; i++) {
        if (type === this.checkedFields[i]) {
          this.checkedFields.splice(i, 1)
        }
      }
    },
    // 关闭对话框
    closeDialog () {
      this.dialogExcal = false
    },
    // 导出Excal
    submit () {
      this.loadingSave = true
      basicdataApi.sysdomainExport('post', '/role/export', {
        PageIndex: this.currentPage,
        PageSize: this.pageSize,
        Sort: this.sort,
        IsAsc: this.IsAsc,
        AllowedMultiUser: -1,
        DomainTypeIds: [],
        Ranks: [],
        SearchVal: this.searchText
      })
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('LanguageLib.ADDED_SUCCESSFULLY1')
          })
          console.log(res)
          this.dialogExcal = false
          // 获取当前日期
          var today = new Date()
          var Month = today.getMonth() + 1
          var day = today.getDate()
          if (Month < 10) {
            Month = '0' + Month
          }
          if (day < 10) {
            day = '0' + day
          }
          var hours = today.getHours() < 10 ? '0' + today.getHours() : today.getHours()
          var minute = today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes()
          var second = today.getSeconds() < 10 ? '0' + today.getSeconds() : today.getSeconds()
          var milliSeconds = today.getMilliseconds()
          var currentDay = today.getFullYear() + '' + Month + '' + day + '' + hours + '' + minute + '' + second + '' + milliSeconds
          var filename = this.$t('LanguageLib.ROLE_DATA_TEMPLATE') + '_' + currentDay + '.xlsx'
          var a = document.createElement('a')
          var url = window.URL.createObjectURL(new Blob([res.data]))
          a.href = url
          a.download = filename
          a.click()
          window.URL.revokeObjectURL(url)
          this.loadingSave = false
        })
        .catch(err => {
          this.loadingSave = false
          this.$commonfun.console.log(err)
        })
    },
    // 添加角色
    addOrg () {
      this.$router.push('/basicdata/rolesetting/addrole?currentPage=' + this.currentPage + '&pageSize=' + this.pageSize + '&searchText=' + this.$commonfun.encodeUrl(this.searchText) + '&sort=' + this.sort + '&IsAsc=' + this.IsAsc + '&type=add')
    },
    // 角色编辑
    editRole (data, index, tableData) {
      if (data.isAllowOperation) {
        this.$router.push('/basicdata/rolesetting/addrole?currentPage=' + this.currentPage + '&pageSize=' + this.pageSize + '&searchText=' + this.$commonfun.encodeUrl(this.searchText) + '&sort=' + this.sort + '&IsAsc=' + this.IsAsc + '&type=edit&data=' + this.$commonfun.encodeUrl(JSON.stringify(data)))
      } else {
        this.$message({
          type: 'info',
          message: this.$t('LanguageLib.NO_EDIT_TIPS')
        })
      }
    },
    // 修改角色权限
    editRoleJurisdiction (data, index, tableData) {
      this.$router.push('/basicdata/rolesetting/updateroleauthority?currentPage=' + this.currentPage + '&pageSize=' + this.pageSize + '&searchText=' + this.$commonfun.encodeUrl(this.searchText) + '&sort=' + this.sort + '&IsAsc=' + this.IsAsc + '&data=' + this.$commonfun.encodeUrl(JSON.stringify(data)))
    }
  },
  watch: {
  }
}
</script>

<style lang="scss">
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.roleSet{
  width:100%;
  height: 100%;
}
.roleSet .left{
  background: #fff;
  width: 20%;
  float:left;
  height: 100%;
  border-right: 1px solid #f2f2f2;
  .treeBox{
    height: calc( 100% - 50px );
    overflow: auto;
    width: 100%;
  }
  .fifter{
    padding: 10px 0 10px 6%;
    line-height: 30px;
   .el-input{
      width: 60%;
    }
    .el-button--text{
      margin-left: 2.5%;
      padding: 2% 0;
      width: 20%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.roleSet .right{
  width: 100%;
  height: 100%;
  .operation{
    background: #fff;
    height: 30px;
    padding: 10px 0 10px 20px;
    border-bottom: 1px solid #f2f2f2;
    border-top: 1px solid #f2f2f2;
    .operationBtn{
      width: auto;
      display: inline-block;
      float:left;
      position: relative;
      .el-button{
        height: 30px;
        padding: 7px 20px;
      }
      .BatchSetting{
        background: #fff;
        color: #666666;
        position:absolute;
        left: 0;
        top: 30px;
        width:100px;
        font-size: 14px;
        text-align:center;
        box-shadow:0px 3px 6px 0px rgba(0,0,0,0.2);
        border-radius:2px;
        z-index: 99;
        li{
          line-height: 30px;
          cursor: pointer;
        }
      }
      .exportType{
        min-width: 100px;
        background: #fff;
        color: #666666;
        position:absolute;
        right: 0;
        top: 30px;
        font-size: 14px;
        text-align:center;
        box-shadow:0px 3px 6px 0px rgba(0,0,0,0.2);
        border-radius:2px;
        z-index: 99;
        li{
          line-height: 30px;
          cursor: pointer;
        }
        .upload{
          position: absolute;
          top: 30px;
          width: 100%;
          opacity: 0;
          .el-upload{
            width: 100%;
            button{
              width: 100%;
              padding-left: 0;
            }
          }
        }
      }
    }
    .operationSearch{
      float:right;
      padding-right: 51px;
      position: relative;
      .shaixuan{
        color: #999999;
        height: 15px;
        width: 15px;
        position: relative;
        top: 2px;
        margin-left: 10px;
        margin-right: 10px;
        font-weight: 600;
      }
      .shaixuan1{
        color: #3BC6B9;
      }
      .el-input{
        width: 160px;
        .el-input__inner{
          height: 30px;
          line-height: 30px;
          border-radius: 20px;
        }
      }
      .el-icon-search{
        line-height: 30px;
      }
    }
  }
  .tableParent{
    height: calc( 100% - 98px );
  }
  .el-pagination{
    padding: 8px 15px 5px;
    height: 35px;
    background: #fff;
  }
}
.roleSet .drawerTitle{
  height:25px;
  font-size:18px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(77,77,77,1);
  line-height:25px;
  margin-bottom: 20px;
}
.roleSet .drawerText{
  height:16px;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(77,77,77,1);
  line-height:16px;
  margin-bottom: 5px;
}
.cell{
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
.el-button--default{
  border:1px solid #3BC6B9;
  color:#3BC6B9;
}
.el-button--primary{
  background-color:#3BC6B9;
  color:#fff;
  border:none;
  margin-left: 10px;
}
.el-button--primary:hover{
  background-color:#3BC6B9;
  color:#fff;
  border:none;
}
/*.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: #3BC6B9 !important;
  border-color: #3BC6B9 !important;
}*/
// 对于树组件配置特有的css
.el-tree-node>.el-tree-node__children{
  overflow: unset;
}
.el-tree-node__content{
  height: 48px;
}
.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
  background-color: #F6F6F6
}
// .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content>span:last-child{
//   color: #3BC6B9 !important;
// }
// .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content>ww-open-data{
//   color: #3BC6B9 !important;
// }
// 更改表格的滚动条样式
.el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar,
.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}
.el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb,
.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
  background: #E1E1E1;
}
.el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-track,
.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track {
  border-radius: 5px;
  background: #fff;
}
// 抽屉组件样式修改
.el-drawer.rtl{
  outline: none;
}
.el-drawer__wrapper{
  top: 172px;
  bottom: 18px;
/*  right: 20px;*/
}
section.el-drawer__body{
  padding: 20px;
  .el-input{
    margin-bottom: 15px;
  }
}
.el-drawer__container{
  outline: none;
}
.colorG{
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(59,198,185,1);
  line-height:20px;
}
.el-table .descending .sort-caret.descending{
}
.el-table .ascending .sort-caret.ascending{
  border-bottom-color: #3BC6B9;
}
.el-pager li.active{
  color: #3BC6B9;
}
.el-table__fixed-body-wrapper .el-table__body{
    padding-bottom: 10px;
}
.filterContent{
  height: calc(100% - 154px);
  overflow: hidden;
  overflow-y: auto;
}
.filterContent::-webkit-scrollbar{
    width: 10px;
    height: 10px;
}
.filterContent::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
  background: #E1E1E1;
}
.filterContent::-webkit-scrollbar-track {
  border-radius: 5px;
  background: #fff;
}
.el-table-column--selection{
  text-align: center !important;
}
.el-tooltip__popper.is-light{
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  border: 1px solid #E4E7ED !important;
  background-color: #fff;
  color: #000;
  .popper__arrow{
    border-top-color: #E4E7ED;
    border: #E4E7ED;
  }
  .popper__arrow::after{
    border-top-color: #fff;
  }
}
.ExcalDialog{
  .el-dialog{
    width: 1000px !important;
    .el-dialog__body{
      height: 350px;
      overflow-y: auto;
    }
    .checkFiled{
      height: 100%;
      border-right: 1px solid #D8DCE6;
      width: calc(70% - 21px);
      padding-right: 20px;
      float: left;
      h4 {
        font-size: 14px;
        color: #999999;
        font-weight: normal;
        padding-bottom: 10px;
        border-bottom: 1px solid #D8DCE6;
        margin-bottom: 15px;
      }
      .contentTop{
        margin-bottom: 15px;
      }
      .el-checkbox{
        margin-bottom: 15px;
      }
    }
    .showFiled{
      width: calc(30% - 20px);
      float: left;
      padding-left: 20px;
      li{
        margin-top: 10px;
        position: relative;
        span{
          padding-right: 20px;
          display: block;
        }
        .el-icon-close{
          position: absolute;
          right: 0;
          top: 3px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
